import { Media } from '@/utils/media'

import { WPPageData } from '@/types'

// eslint-disable-next-line no-unused-vars
export const getPagePrecacheMedia = (pageData: WPPageData) => {
  // const builder = pageData?.acf?.builder
  // const hero = builder[0]
  // const image = hero.image

  return [] as Media[]
  /* return (
    image !== undefined
      ? [
          {
            src: image.url,
            type: 'image'
          }
        ]
      : []
  ) as Media[] */
}
